import {
    Component,
    forwardRef,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { IMapComponent, MapExtent } from "../../../map.models";
import { IMapSettings } from "../../../map.settings";
import { MapBaseSubComponent } from "../map-base-sub-component/map-base-sub.component";

@Component({
    selector: "rask-map-home",
    templateUrl: "./map-home.component.html",
    styleUrls: ["./map-home.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        { provide: MapBaseSubComponent,
            useExisting: forwardRef(() => MapHomeComponent) }
    ]
})
export class MapHomeComponent extends MapBaseSubComponent implements OnInit {

    @Input() hidden = false;
    @Input() extent: MapExtent;
    widgetId = "map-home";
    mapsettings: IMapSettings;
    map: IMapComponent;
    buttons = [
        {
            iconClass: "fa-regular fa-house-person-return",
            tooltipText: "Panorera hem",
            visible: () => !this.hidden,
            disabled: this.disabled,
            widgetId: "map-zoom-all",
            click: () => {
                if (this.mapsettings.onHomeClick) {
                    this.mapsettings.onHomeClick();
                } else if (this.extent) {
                    this.map.gotoExtent(this.extent);
                } else {
                    this.map.gotoSelectedOrDefault();
                }
            }
        }
    ];
    arcView: any;

    constructor() {
        super();
    }

    preInit(mapsettings: IMapSettings) {
        this.mapsettings = mapsettings;
    }

    onInit(arcView, arcDraw) {
        this.arcView = arcView;
    }

    ngOnInit(): void {
        this.mapReady.pipe(
            takeUntil(this.destroy$)
        ).subscribe(instance => {
            this.map = instance;
        });
    }
}
